module.exports = __webpack_public_path__ + "img/shiba-loading.7923d968.png";